export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_1600000-6bf0dd6d1deca5bc8238cc6cbd4e1bf8.avif";